<!-- The email editor's icons (Feather-style strokes, as Edit.vue): star (outline or filled),
     chevron, trash, restore, plus -->

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :fill="name === 'star-filled' ? 'currentColor' : 'none'"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <path v-for="path in PATHS[name]" :key="path" :d="path" />
  </svg>
</template>

<script setup>
defineProps({name: {type: String, required: true}});

const STAR =
  "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z";
const PATHS = {
  "star": [STAR],
  "star-filled": [STAR],
  "chevron": ["M9 18l6-6-6-6"],
  "trash": ["M3 6h18", "M8 6V4h8v2", "M19 6l-1 14H6L5 6", "M10 11v6", "M14 11v6"],
  "restore": ["M3 12a9 9 0 1 0 3-6.7", "M3 4v5h5"],
  "plus": ["M12 5v14", "M5 12h14"],
};
</script>

<style scoped>
svg {
  height: 16px;
  width: 16px;
  flex: none;
}
</style>
